import "./NavigationTopBarComponent.scss";
import template from "./NavigationTopBarComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {NavigationModelService} from "../../service/NavigationModelService";
import {Observable, ReplaySubject} from "rxjs";
import {NavigationItems} from "../../models/NavigationItems";
import {AccountStore} from "../../../account/store/AccountStore";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const NavigationTopBar = "tfNavigationTopBar";

export function navigationTopBar(parentDir: string): IComponentOptions {
    return {
        template,
        controller: NavigationTopBarComponent,
        controllerAs: "ctrl"
    };
}

export class NavigationTopBarComponent implements IOnInit, IOnDestroy {

    public showSidebarToggle: Observable<boolean>;
    public navItems: Observable<NavigationItems>;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly navigationModelService: NavigationModelService,
                       readonly accountStore: AccountStore,
                       readonly currentUserService: CurrentUserService) {
    }

    public $onInit(): void {
        const sidebarVisible$ = this.navigationModelService
                                    .sidebarVisible
                                    .takeUntil(this.destroyed$);
        const isMobileSidebar$ = this.navigationModelService.isMobileNav.takeUntil(this.destroyed$);
        this.showSidebarToggle = Observable.combineLatest(sidebarVisible$, isMobileSidebar$)
                                           .map(([sidebarVisible, isMobile]) => sidebarVisible && isMobile);

        this.navItems = this.navigationModelService
                            .topNavModel
                            .takeUntil(this.destroyed$)
                            .map((model) => model.navigationItems);
    }

    public toggleSidebar() {
        this.navigationModelService.toggleSidebar();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
